import {
  get,
  set,
  isString,
  isFunction,
  isObject,
  toPath,
  last
} from 'lodash';


let data = global.name;
try {
  data = JSON.parse(data);
  if ( !isObject(data) ) {
    data = {};
  }
} catch(e){}
class Memory {

  static data = data;

  static getItem(key){
    return (key in Memory.data) ? Memory.data[key] : null;
  }

  static setItem(key, value){
    set(Memory.data, key, value);
    global.name = JSON.stringify(Memory.data);
    return value;
  }

  static removeItem(key){
    try {
      delete Memory.data[key];
      global.name = JSON.stringify(Memory.data);
    } catch(e) {

    }
  }
}

class MemoryCache {

  _config = null;

  localStorage = Memory;

  result;

  constructor(config){

    if ( !config.keyName ) {
      throw new Error(`${config.keyName} can not be empty!`);
    }

    this._config = config;

    try {
      this.result = this.localStorage.getItem(config.keyName);
    } catch (e){

    }
  }

  /**
   *
   * @param key
   * @param value
   * @param callback
   * @return {{}}
   */
  set(key, value = null, callback){
    let keyName = this.config('keyName');
    if ( !isString(key) ) {
      callback = value;
      value = key;
      key = undefined;
    }
    if( key === undefined ) {
      this.result = value;
    } else if(isString(key)) {
      set(this, 'result.' + key, value);
    }

    if(this.result === undefined || this.result === null) {
      this.localStorage.removeItem(keyName);
    } else {
      this.localStorage.setItem(keyName, this.result);
    }

    return isFunction(callback) ? callback(this.result) : this.result;
  }

  /**
   *
   * @param key
   * @param callback
   * @return {{}}
   */
  get(key, callback){
    let ret;
    if ( isString(key) ) {
      ret = get(this, 'result.' + key, null)
    } else {
      ret = get(this,'result', null);
    }
    return isFunction(callback) ? callback(ret) : ret;
  }

  /**
   * 清除缓存数据
   * @param {string} [key]
   * @param {function(data)} callback
   * @return {*}
   */
  clear(key, callback){
    if(isFunction(key)) {
      callback = key;
      key = undefined;
    }
    if ( isString(key) ) {
      let path = toPath(key);
      let value = path.length >= 2 ? get(this.result, path.slice(0, -1), null) : this.result;
      let lastKey = last(path);
      if ( value && (lastKey in value) ) {
        try {
          delete value[lastKey];
        } catch (e){}
      }
    } else {
      this.result = null;
    }
    let result = this.result;
    if(result === null || result === undefined) {
      this.localStorage.removeItem(this.config('keyName'));
    } else {
      this.localStorage.setItem(this.config('keyName'), result);
    }

    return isFunction(callback) ? callback(this.result) : this.result;
  }

  /**
   * 配置当前model信息
   * @param {string} [key]
   * @param {any} [value]
   * @return {*}
   */
  config(key, value){
    if (isString(key) && value != undefined) {
      set(this, '_config.' + key, value);
    }
    return key ? get(this, '_config.' + key, null) : this._config;
  }

  /**
   * 把当前对象转成JSON数据
   * @return {*}
   */
  toJSON(){
    return this.result;
  }
}

export default MemoryCache;


// WEBPACK FOOTER //
// ./src/class/Storage/MemoryCache.js